import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Entity, Shapeable, IconComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme'
import { classNames } from '@shapeable/utils';
import { ChevronLeftThinIconGlyph, TagDotIconGlyph } from '@shapeable/icons';
import { EntityValue, useView } from '@shapeable/ui';
const cls = classNames('entity-conversation-banner');

// -------- Types -------->

export type EntityConversationMobileHeaderProps = Classable & HasChildren & {
  entity?: Entity;
  allItemsTitle?: string;
  allItemsIcon?: IconComponent;
  showActiveEntity?: boolean;
  returnToView?: string;
}

export const EntityConversationMobileHeaderDefaultProps: Omit<EntityConversationMobileHeaderProps, 'entity'> = {
  showActiveEntity: true,
  allItemsTitle: 'All Items',
  allItemsIcon: TagDotIconGlyph,
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    gap: ${theme.UNIT(5)};
    margin-top: 1px;
    padding: ${theme.UNIT(2)} ${theme.UNIT(3)};
    border-bottom: 1px solid ${theme.COLOR('line-subtle')};
    background-color: ${theme.COLOR('appChrome')};

    cursor: pointer;
    width: 100%;
  `,
  desktop: css`
    display: none;
  `
});


const ActiveConversationEntityStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
    ActiveConversationEntity: styled(EntityValue)`${ActiveConversationEntityStyles}`,

};

export const EntityConversationMobileHeader: Shapeable.FC<EntityConversationMobileHeaderProps> = (props) => {
  const { entity, className, returnToView } = props;

  const { setActiveSubView } = useView(entity?.slug);
  
  return (
    <My.Container className={className} onClick={() => setActiveSubView('aside')}>
      <ChevronLeftThinIconGlyph size={32} />
      {
        !!entity &&
        <My.ActiveConversationEntity entity={entity} />
      }
    </My.Container>
  )
};

// EntityConversationMobileHeader.defaultProps = EntityConversationMobileHeaderDefaultProps;
EntityConversationMobileHeader.cls = cls;